// Third Party
import React from 'react';

type Props = {
  height: number;
  width: number;
};

const Circle = ({ width, height }: Props) => <div style={{ width, height }} className="circle" />;

export default Circle;
